import { IconType } from '@shared/utils/icons';

export class ButtonGroupTabModel {
  constructor(public buttonName: string, public icon?: IconType) {}
}
